import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  /* flex-wrap: wrap; */
  /* overflow: hidden; */
  /* background-color: red; */
  /* padding: 10px; */
`;

export const SingleCard = styled.div`
  flex: 1 1 calc(33% - 10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.bgcolor || "#f2f2f2"};
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  /* margin: 10px 0; */
  text-align: center;
  color: #333;
  /* height: 360px; */
  /* overflow: visible; */

  h4 {
    font-size: clamp(21px, 1.6vw, 3em);
    font-weight: 600;
    margin-bottom: 10px;
  }

  p {
    font-size: clamp(16px, 1.2vw, 5em);
    margin-bottom: auto;
    color: #666;
    /* overflow: auto; */
  }

  img {
    width: 100px;
    height: 100px;
  }

  &:hover {
    background-color: #fff;
  }
  @media (max-width: 768px) {
    /* height: 320px; */
    flex: 1 1 calc(50% - 10px);
  }

  @media (max-width: 576px) {
    flex: 1 1 calc(100%);
  }
`;
